import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { formatLargeNumber } from '@/utils/formatLargNumber';
import { Box } from '@mui/material';

const ColumnChartInadimplenciaVisaoAnual = ({ selectedData }) => {
  if (!selectedData) return null;

  const months = selectedData.map((item) => item.ano);
  const pagoData = selectedData.map((item) => item.valor);
  const vencidoData = selectedData.map((item) => item.valor_secundario);
  const percentualInadimplenciaData = selectedData.map((item) => item.valor_terciario);

  const option = {
    title: {
      text: 'Visão Histórica anual da Inadimplência',
      padding: [
        16,
        5,
        5,
        23,
      ],
      textStyle: {
        fontSize: '14px',
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999',
        },
      },
      formatter: (params) => {
        const tooltipItems = params.map((item) => {
          const value = item.value;
          const formattedValue = item.seriesName === 'Percentual de Inadimplência' ? `${value}%` : formatLargeNumber(value);
          return `<div><strong>${item.seriesName}:</strong> ${formattedValue}</div>`;
        }).join('');
        return `<div><strong>${params[0].name}</strong></div>${tooltipItems}`;
      },
    },
    legend: {
      data: [
        {name: 'Percentual de Inadimplência'},
        {name: 'Valor real inadimplente', icon: 'circle'},
        {name: 'Valor inadimplente acumulado', icon: 'circle'}
      ],
      right: '0',
      padding: [
        16,
        23,
        5,
        5,
      ],
    },
    grid: {
      left: '3%',
      right: '6%',
      bottom: '3%',
      top: '20%',
      containLabel: true,
    },
    yAxis: [
      {
        type: 'value',
        name: 'Valor',
        position: 'left',
      },
      {
        type: 'value',
        name: 'Percentual',
        position: 'right',
        axisLabel: {
          formatter: '{value}%',
        },
      },
    ],
    xAxis: {
      type: 'category',
      data: months,
      axisLabel: {
        formatter: (value, index) => {
          return `{percent|${percentualInadimplenciaData[index].toFixed(2)}%}\n{value|${value}}`;
        },
        rich: {
          percent: {
            fontSize: 12,
            color: '#000',
            fontWeight: 'bold',
            padding: [0, 0, 0, 0], 
          },
          value: {
            fontSize: 12,
            color: '#000',
            padding: [5, 0, 0, 0],
          },
        },
      },
    },
    series: [
      {
        name: 'Valor inadimplente acumulado',
        type: 'bar',
        stack: 'total',
        data: pagoData,
        barMaxWidth: 60,
        itemStyle: {
          borderRadius: [10, 10, 0, 0],
          color: '#15ab51',
        },
        label: {
          show: true,
          formatter: (params) => formatLargeNumber(Number(params.value)),
          position: 'top',
          backgroundColor: '#93dc3f',
          padding: [5, 10],
          borderRadius: [5],
          fontWeight: 'bold',
        },
      },
      {
        name: 'Qtd. boletos em aberto',
        type: 'bar',
        stack: 'total',
        data: vencidoData,
        barMaxWidth: 60,
        itemStyle: {
          color: '#15ab51',
        },
      },
      {
        name: 'Percentual de Inadimplência',
        type: 'line',
        smooth: true,
        yAxisIndex: 1,
        data: percentualInadimplenciaData,
        lineStyle: {
          color: 'black',
          width: 3,
        },
      },
    ],
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default ColumnChartInadimplenciaVisaoAnual;
